var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoAccountUpdates = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_account_updates",
    d: "M167.855,689.76a3.559,3.559,0,1,1-3.438,3.556A3.5,3.5,0,0,1,167.855,689.76Zm1.323,11.909a6.058,6.058,0,0,1,1.33-3.793,1.115,1.115,0,0,0-.593.225,3.769,3.769,0,0,1-4.807-.023,1.068,1.068,0,0,0-.919-.212,6.964,6.964,0,0,0-4.253,6.019c-.1.939.394,3.23,7.538,3.262a19.171,19.171,0,0,0,4.432-.406A6.119,6.119,0,0,1,169.178,701.669Zm2.525.092a3.357,3.357,0,0,1,3.163-3.543l.184-.006.013,1.264a.093.093,0,0,0,.1.083.091.091,0,0,0,.047-.018l2.612-1.89a.083.083,0,0,0,0-.117l-.009-.008-2.643-1.939a.094.094,0,0,0-.129.013.1.1,0,0,0-.02.05l.013,1.266a4.613,4.613,0,0,0-4.613,5.2,4.772,4.772,0,0,0,1.463,2.853l1.076-.775A3.469,3.469,0,0,1,171.7,701.761Zm3.575,4.65a4.616,4.616,0,0,0,4.61-5.206,4.774,4.774,0,0,0-1.463-2.854l-1.072.775a3.477,3.477,0,0,1,1.256,2.44,3.354,3.354,0,0,1-3.161,3.542c-.062,0-.124.006-.185.006l-.009-1.262a.094.094,0,0,0-.1-.083.1.1,0,0,0-.047.018l-2.609,1.887a.083.083,0,0,0-.01.117l.011.011,2.647,1.938a.091.091,0,0,0,.129-.015.082.082,0,0,0,.019-.047Z",
    transform: "translate(-159.925 -689.76)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoAccountUpdates);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_account_updates.c82e8e3e08035b78c7c889aa30c2d1b1.svg";